/*
 * NOTE: DisplayDate is being deprecated because it cannot
 * represent certain hours in the day daylight-savings ends
 * in the time zone of the user's MACHINE. Use OwaDate instead.
 * For the same reason, don't use date-fns; use functions from owaDate.
 *
 * Until we have everything converted, use these functions to bridge the gaps.
 */
export { DisplayDate, OwaDate } from 'owa-datetime';
export { default as displayDateToOwaDate } from './displayDateToOwaDate';
export { default as owaDateToDisplayDate } from './owaDateToDisplayDate';
export { default as owaDateToDisplayDateCallback } from './owaDateToDisplayDateCallback';
